export const fontWeightOptions = {
  LIGHT: "Light",
  REGULAR: "Regular",
  SEMI_BOLD: "Semi-bold"
};

export const typographyWeights = {
  [fontWeightOptions.LIGHT]: 300,
  [fontWeightOptions.REGULAR]: 400,
  [fontWeightOptions.SEMI_BOLD]: 600
};
